import { parseCoachingMessage } from '../../voice-agent/utils/parseCoachingMessage';
import type { CoachMessage, CoachMessageRole, CoachUpstreamMessage, PendingKeywordTag } from './types';

const resolveRole = (message: CoachUpstreamMessage): CoachMessageRole => {
	if (message.role === 'assistant') return 'assistant';
	if (message.messageType === 'transcript') return 'transcript';
	return 'user';
};

const formatTime = (timestamp: Date): string =>
	timestamp.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });

/** Normalizes an upstream message for the view; keyword tags only apply to the lead's coaching chat. */
export const toCoachMessage = (
	message: CoachUpstreamMessage,
	tagForRequest: Map<string, PendingKeywordTag> = new Map()
): CoachMessage => {
	const role = resolveRole(message);
	const base: CoachMessage = {
		id: message.id,
		role,
		time: formatTime(message.timestamp),
		text: message.text,
		isStreaming: message.isStreaming || undefined,
	};

	if (role === 'assistant') {
		const parsed = parseCoachingMessage(message.text);
		if (parsed?.suggestion) base.sayThis = parsed.suggestion;
		if (parsed?.reasoning) base.why = parsed.reasoning;

		const tag = message.requestId ? tagForRequest.get(message.requestId) : undefined;
		if (tag) {
			base.pinnedKeyword = tag.pinnedKeyword;
			base.pinColor = tag.pinColor;
		}
	}

	return base;
};
